import { Table } from '@tanstack/react-table'

/**
 * Linhas-folha na ordem em que a tela as mostra. Lê o modelo ordenado do grid,
 * já filtrado e agrupado e ainda não paginado — o arquivo leva o relatório
 * inteiro, não a página aberta.
 *
 * Devolve `undefined` enquanto o grid não publicou a tabela no contexto (o
 * `apiRef` só é preenchido por efeito, depois do primeiro render).
 */
export function folhasNaOrdemDaTela<T>(table?: Table<any> | null) {
    return table
        ?.getSortedRowModel()
        .flatRows.filter(linha => !linha.getIsGrouped())
        .map(linha => linha.original as T)
}
